
import React, { Fragment, useEffect, useState } from 'react';
import { ArrowLeft, ArrowRight } from 'react-feather';
import SidebarMenuItems from './SidebarMenuItems';
import ConfigDB from '../../Config/ThemeConfig';
import Sidebarimgsection from './Sidebarimgsection';
import Popup from '../../Components/Common/Popup/popup';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

const SidebarMenu = ({ width }) => {
  const [rightArrow, setRightArrow] = useState(false);
  const [leftArrow, setLeftArrow] = useState(false);
  const sidebar_types = localStorage.getItem('sidebar_types');
  const newUpdate = localStorage.getItem('new_update');
  const wrapper = sidebar_types || ConfigDB.data.settings.sidebar.type;
  const [margin, setMargin] = useState(0);
  const [modal, setModal] = useState(false)
  const authState = useSelector((state) => state.auth);
  const navigate = useNavigate()

  // const today = new Date().toISOString().split("T")[0]; 

  //modal open
  // const handleModal = () => {
  //   localStorage.setItem("modalLastOpened", today);
  //   setModal(!modal)
  // }
  // const handleGoMessage = () => {
  //   localStorage.setItem("modalLastOpened", today);
  //   if (authState.userRole === 1) {
  //     navigate('/settings/message-credit')
  //   }
  //   setModal(false)

  // }

  useEffect(() => {
    setLeftArrow(true);
    // const today = new Date().toISOString().split("T")[0]; 
    // const lastOpened = localStorage.getItem("modalLastOpened");

    // if (lastOpened !== today) {
    //   setModal(true); 
    //   localStorage.setItem("modalLastOpened", today);
    // }
  }, []);

  const scrollToRight = () => {
    if (margin <= -2598 || margin <= -2034) {
      if (width === 492) {
        setMargin(-3570);
      } else {
        setMargin(-3464);
      }
      setRightArrow(true);
      setLeftArrow(false);
    } else {
      setLeftArrow(false);
      setMargin(margin => (margin += -width));
    }
  };

  const scrollToLeft = () => {
    if (margin >= -width) {
      setMargin(0);
      setLeftArrow(true);
      setRightArrow(false);
    } else {
      setMargin(margin => (margin += width));
      setRightArrow(false);
    }
  };

  return (
    <Fragment>
      <nav className='sidebar-main'>
        <div className={`left-arrow ${leftArrow ? 'd-none' : ''}`} id="left-arrow" onClick={scrollToLeft}><ArrowLeft /></div>
        <div id="sidebar-menu">
          <SidebarMenuItems wrapper={wrapper} margin={margin} />
        </div>
        <div className={`right-arrow ${rightArrow ? 'd-none' : ''}`} onClick={scrollToRight}>
          <ArrowRight />
        </div>
      </nav>
      {/* <Popup isOpen={modal} toggler={handleModal} size="lg" title='New Update' >
        <div >
          <h4 className="modal-title fw-semibold">
            🎉 BillerQ Subscription Update (Effective from 1st January 2026) 🎉
          </h4>

          <div className=" mt-3 d-flex flex-column align-items-start justify-content-end">
            <span>✨ Happy New Year 2026! ✨</span>
            <span>
              We thank you for being a valued part of the BillerQ family and wish you a year filled with growth, success, and seamless billing experiences.
            </span>
            <br />
            <span>
              🎊 Good News!
            </span>
            <span>
              We are happy to announce a price reduction in the BillerQ subscription:
            </span>
            <span>💰From <strong>₹ <strong>2</strong> </strong> to <strong> ₹ 1.60 </strong> per connection, effective <strong> 1st January 2026.</strong> </span>
            <span>🔔SMS & WhatsApp Notifications Update.</span>
            <span>SMS and WhatsApp notifications are now detached from the core application. Customers who wish to enable notifications can do so separately.</span>

            <br />
            <ul>
              <li>
                📩 Notification Charges:
              </li>
              <li>
                * SMS: <strong>₹0.22 </strong> per message
              </li>
              <li>
                * WhatsApp: <strong>₹0.22</strong>  per message
              </li>
            </ul>
            <br />
            <span>
              👉 To enable SMS or WhatsApp notifications, please go to :
              <strong className='mx-1'>
                Settings → Message Credit.
              </strong>
              <br />
              <span>
                This update gives you greater flexibility and better control over your communication costs.
                For any questions or support, feel free to contact us.
              </span>
            </span>
          </div>

        </div>
        <div className="d-flex justify-content-end ">
          <button
            className="btn btn-primary px-4 "
            onClick={handleGoMessage}
          >
            {
              authState?.userRole === 1 ? 'Add Message Credit' :
                'I Understood'
            }

          </button>
        </div>

      </Popup> */}
    </Fragment>
  );
};

export default SidebarMenu;
